<template>
  <v-card>
    <l-map
      :style="mapStyles"
      ref="map"
      :options="{ scrollWheelZoom: false }"
      :zoom="zoom"
      :center="center"
      :maxZoom="maxZoom"
      :key="mapsKey"
    >
      <l-tile-layer
        :url="url"
        :attribution="attribution"
      ></l-tile-layer>
      <l-marker
        v-if="alkor"
        :lat-lng="[alkor.geometry.coordinates[1], alkor.geometry.coordinates[0]]"
        :icon="alkorIcon"
      > </l-marker>
      <l-marker
        v-if="sonne"
        :lat-lng="[sonne.geometry.coordinates[1], sonne.geometry.coordinates[0]]"
        :icon="sonneIcon"
      > </l-marker>
      <l-marker
        v-if="merian"
        :lat-lng="[merian.geometry.coordinates[1], merian.geometry.coordinates[0]]"
        :icon="merianIcon"
      > </l-marker>
      <l-marker
        v-if="meteor"
        :lat-lng="[meteor.geometry.coordinates[1], meteor.geometry.coordinates[0]]"
        :icon="meteorIcon"
      >
      </l-marker>
    </l-map>
  </v-card>
</template>

<script>
import { LMap, LTileLayer, LMarker, LTooltip, LIcon } from 'vue2-leaflet';

export default {
  name: 'Map',
  props: ['height'],
  components: {
    LMap,
    LTileLayer,
    LMarker,
    LTooltip,
    LIcon,
  },
  data() {
    return {
      mapsKey: 0,
      url: 'https://server.arcgisonline.com/ArcGIS/rest/services/Ocean/World_Ocean_Base/MapServer/tile/{z}/{y}/{x}',
      attribution: 'Tiles &copy; Esri &mdash; Sources: GEBCO, NOAA, CHS, OSU, UNH, CSUMB, National Geographic, DeLorme, NAVTEQ, and Esri',
      maxZoom: 10,
      center: [30.0, 0.0],
      zoom: 2,
      alkorIcon: L.icon({
        iconUrl:
          "https://maps.geomar.de/mapgen_ds/assets/map_icons/alkor-b0968c9577a76bd38779cffa5989a317.gif",
        iconSize: [36, 30],
        iconAnchor: [18, 30],
      }),
      sonneIcon: L.icon({
        iconUrl:
          "https://maps.geomar.de/mapgen_ds/assets/map_icons/sonne-c81019a116334565114e61fb6fb20208.gif",
        iconSize: [36, 30],
        iconAnchor: [18, 30],
      }),
      merianIcon: L.icon({
        iconUrl:
          "https://maps.geomar.de/mapgen_ds/assets/map_icons/merian-66051f73c604718355f3581452b7fd46.gif",
        iconSize: [36, 30],
        iconAnchor: [18, 30],
      }),
      meteorIcon: L.icon({
        iconUrl:
          "https://maps.geomar.de/mapgen_ds/assets/map_icons/meteor-abd7c5ef3ae40e371eff796f367510b1.gif",
        iconSize: [36, 30],
        iconAnchor: [18, 30],
      }),
      alkor: null,
      sonne: null,
      merian: null,
      meteor: null,
    };
  },
  computed: {
    dynamicSize() {
      return [this.iconSize, this.iconSize * 1.15];
    },
    dynamicAnchor() {
      return [this.iconSize / 2, this.iconSize * 1.15];
    },
    mapStyles() {
      return {
        height: `${this.height}px`
      };
    }
  },
  mounted() {
    this.getAlkorPosition()
    this.getSonnePosition()
    this.getMerianPosition()
    this.getMeteorPosition()
    this.forceRerender()
  },
  watch: {
  },
  methods: {
    async getAlkorPosition() {
      try {
        const response = await fetch("https://maps.geomar.de/mapgen_ds/platforms/currentloc?id=AL");

        // Check if the response status is OK
        if (response.ok) {
          const data = await response.json();
          this.alkor = data;
        } else {
          // Handle non-OK responses
          console.error("Failed to fetch Alkor position:", response.status, response.statusText);
          // Optionally, you can set a default value or take other actions here
        }
      } catch (error) {
        // Handle any other errors, including network errors
        console.error("An error occurred while fetching Alkor position:", error);
        // Optionally, you can set a default value or take other actions here
      }
    },
    async getSonnePosition() {
      try {
        const response = await fetch("https://maps.geomar.de/mapgen_ds/platforms/currentloc?id=SO");

        // Check if the response status is OK
        if (response.ok) {
          const data = await response.json();
          this.sonne = data;
        } else {
          // Handle non-OK responses
          console.error("Failed to fetch Sonne position:", response.status, response.statusText);
          // Optionally, you can set a default value or take other actions here
        }
      } catch (error) {
        // Handle any other errors, including network errors
        console.error("An error occurred while fetching Sonne position:", error);
        // Optionally, you can set a default value or take other actions here
      }
    },
    async getMerianPosition() {
      try {
        const response = await fetch("https://maps.geomar.de/mapgen_ds/platforms/currentloc?id=MSM");

        // Check if the response status is OK
        if (response.ok) {
          const data = await response.json();
          this.merian = data;
        } else {
          // Handle non-OK responses
          console.error("Failed to fetch Merian position:", response.status, response.statusText);
          // Optionally, you can set a default value or take other actions here
        }
      } catch (error) {
        // Handle any other errors, including network errors
        console.error("An error occurred while fetching Merian position:", error);
        // Optionally, you can set a default value or take other actions here
      }
    },
    async getMeteorPosition() {
      try {
        const response = await fetch("https://maps.geomar.de/mapgen_ds/platforms/currentloc?id=M");

        // Check if the response status is OK
        if (response.ok) {
          const data = await response.json();
          this.meteor = data;
        } else {
          // Handle non-OK responses
          console.error("Failed to fetch Meteor position:", response.status, response.statusText);
          // Optionally, you can set a default value or take other actions here
        }
      } catch (error) {
        // Handle any other errors, including network errors
        console.error("An error occurred while fetching Meteor position:", error);
        // Optionally, you can set a default value or take other actions here
      }
    },
    forceRerender() {
      this.$nextTick(() => {
        this.mapsKey += 1
      })
    },
  },
}
</script>
